"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounceByTick = exports.cancelSchedulerCallback = exports.requestSchedulerCallback = exports.cancelIdleCallback = exports.requestIdleCallback = void 0;

var Scheduler = _interopRequireWildcard(require("scheduler"));

/* eslint-disable compat/compat */
var requestIdleCallback = window.requestIdleCallback || setTimeout;
exports.requestIdleCallback = requestIdleCallback;
var cancelIdleCallback = window.cancelIdleCallback || clearTimeout;
exports.cancelIdleCallback = cancelIdleCallback;

var requestSchedulerCallback = function requestSchedulerCallback(callback) {
  return Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, callback);
};

exports.requestSchedulerCallback = requestSchedulerCallback;

var cancelSchedulerCallback = function cancelSchedulerCallback(id) {
  if (id) {
    Scheduler.unstable_cancelCallback(id);
  }
};
/**
 * Debounce function that uses Promise resolution for timing, resulting in a shorter delay than
 * `setTimeout()` in modern browsers.
 *
 * Borrowed from Popper.js:
 * https://github.com/popperjs/popper-core/blob/be548db65912e1126581a44faa7f758ff004680a/src/utils/debounce.js
 *
 * @param {Function} callback
 */


exports.cancelSchedulerCallback = cancelSchedulerCallback;

var debounceByTick = function debounceByTick(callback) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(callback());
        });
      });
    }

    return pending;
  };
};

exports.debounceByTick = debounceByTick;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/Timers.js
// module id = 203
// module chunks = 209 210 211 212